import React, { useContext, useMemo, useCallback } from 'react';
import { withCollapseAdapter } from '@bingads-webui-campaign-react/validated-form-cards';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  AccordionCard,
  FormCardBody,
  FormCardHeader,
  Spacer,
  FormCardError,
  AccordionButton,
  FormCardSummary,
  FormCard,
} from '@bingads-webui-fluent-component/form-cards';
import { makeStyles } from '@fluentui/react-components';
import { Label } from '@bingads-webui-react/fluent-controls';
import { CustomExpandableActuator } from '@bingads-webui-campaign-react/actuator';
import { withContainerPropInjectingErrorHandling } from '@bingads-webui-campaign-react/error-handling';

const useClasses = makeStyles({
  root: {
    marginBottom: '8px',
  },
});

export const ValidatedPanelInternal = ({
  title,
  children,
  open,
  id,
  ...rest
}) => {
  const i18n = useContext(I18nContext);

  const classes = useClasses();

  const shouldRenderSummary = useMemo(() => title && title.props && title.props.details, [title]);

  const renderTitle = useCallback(() => {
    let titleTpl = null;
    if (typeof title === 'string') {
      titleTpl = <Label className="collapse-title" >{i18n.getString(_TL_('{{item}}'), { item: title })}</Label>;
    } else {
      titleTpl = React.cloneElement(title, { details: null, isActive: open });
    }

    return titleTpl;
  }, [title, open, i18n]);

  const renderSummary = useCallback(() => {
    let summaryTpl = null;

    const titleDetails = title.props.details;
    if (typeof titleDetails === 'string') {
      summaryTpl = <Label className="collapse-summary" >{i18n.getString(_TL_('{{item}}'), { item: titleDetails })}</Label>;
    } else {
      summaryTpl = React.cloneElement(titleDetails);
    }

    return summaryTpl;
  }, [title, i18n]);

  return (
    <AccordionCard className={classNames('collapse-panel', id, classes.root)} open={open} {...rest}>
      <FormCardHeader>
        {renderTitle()}
        <Spacer />
        <FormCardError />
        <AccordionButton />
      </FormCardHeader>
      {shouldRenderSummary && !open && <FormCardSummary>{renderSummary()}</FormCardSummary>}
      <FormCardBody>
        {children}
      </FormCardBody>
    </AccordionCard>
  );
};

export const ValidatedPanel = withCollapseAdapter(withContainerPropInjectingErrorHandling(ValidatedPanelInternal, [CustomExpandableActuator]));


export const ValidatedFixedPanelInternal = ({
  title,
  children,
  id,
  ...rest
}) => {
  const classes = useClasses();

  return (
    <FormCard className={classNames('collapse-panel', 'collapse-fixed-panel', id, classes.root)} {...rest}>
      <FormCardHeader>
        {title}
      </FormCardHeader>
      <FormCardBody>
        {children}
      </FormCardBody>
    </FormCard>
  );
};

export const ValidatedFixedPanel = withContainerPropInjectingErrorHandling(ValidatedFixedPanelInternal);
